import { LoadState } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { useMemo } from 'react';

import { Chip } from '~components/Chip/Chip';
import { snakeCaseToHuman } from '~utils/utilFunctions';

interface LoadStateExtended {
  label: string;
  color: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
}
interface Props {
  status: LoadState | undefined;
  textOnly?: boolean;
  hideDropdownArrow?: boolean;
}

const Status = ({ status, textOnly, hideDropdownArrow = true }: Props) => {
  const Statuses = {
    _: { label: snakeCaseToHuman(`${status}`), color: 'info' },
    [LoadState.CREATED]: { label: t('status.planned'), color: 'primary' },
    [LoadState.TO_PICKUP]: { label: t('status.to_pickup'), color: 'info' },
    [LoadState.ARRIVED_PICKUP]: { label: t('status.arrived_pickup'), color: 'info' },
    [LoadState.LOADED]: { label: t('status.loaded'), color: 'info' },
    [LoadState.TO_DROPOFF]: { label: t('status.to_dropoff'), color: 'info' },
    [LoadState.ARRIVED_DROPOFF]: { label: t('status.arrived_dropoff'), color: 'info' },
    [LoadState.UNLOADED]: { label: t('status.unloaded'), color: 'info' },
    [LoadState.COMPLETED]: { label: t('status.delivered'), color: 'success' },
    [LoadState.CANCELED]: { label: t('status.canceled'), color: 'error' },
  } as Record<LoadState | string, LoadStateExtended>;

  const value = useMemo(
    () => (status ? Statuses[status] || Statuses._ : Statuses._),
    [status],
  );

  return textOnly ? (
    <>{value.label}</>
  ) : (
    <Chip label={value.label} color={value.color} hideDropdownArrow={hideDropdownArrow} />
  );
};

export { Status };
